<template>
    <content-page page-name="ABOUT"></content-page>
</template>

<script>
import ContentPage from "../components/ContentPage";

export default {
    name: "about",

    components: { ContentPage }
};
</script>
